import React from 'react';
import {
  Control,
  FieldErrors,
  FieldPathByValue,
  FieldValues,
  UseFormClearErrors,
  UseFormSetValue,
} from 'react-hook-form';
import { Typography } from '@naf-simba/building-blocks-typography';
import { GridCol } from '@naf/grid';
import { InternalDialogArticle } from '@components/InternalDialogArticle/InternalDialogArticle';
import { MainMemberConsent } from '../../../../../../types/membersFormType';
import { ConsentsForms } from './ConsentsForm/ConsentsForm';
import * as S from './Consents.styles';

type ConsentPath<TFormValues extends FieldValues> = FieldPathByValue<TFormValues, MainMemberConsent[]>;

interface ConsentsProps<TFormValues extends FieldValues> {
  errors: FieldErrors<TFormValues>;
  setValue: UseFormSetValue<TFormValues>;
  control: Control<TFormValues>;
  clearErrors: UseFormClearErrors<TFormValues>;
  consentPath?: ConsentPath<TFormValues>;
  initialConsents?: MainMemberConsent[];
  topMargin?: boolean;
}

export const Consents = <TFormValues extends FieldValues>({
  setValue,
  control,
  clearErrors,
  errors,
  consentPath = 'mainMember.consents' as ConsentPath<TFormValues>,
  initialConsents,
  topMargin = false,
}: ConsentsProps<TFormValues>) => (
  <S.StyledGrid topMargin={topMargin}>
    <GridCol s="12" m="12" l="12" xl="12">
      <S.TitleWrapper>
        <Typography variant="titleXL" id="consents">
          Kommunikasjonsvalg og samtykker
        </Typography>
      </S.TitleWrapper>
      <ConsentsForms
        setValue={setValue}
        control={control}
        clearErrors={clearErrors}
        errors={errors}
        consentPath={consentPath}
        initialConsents={initialConsents}
      />
      <S.TermsConsent>
        <S.TermsConsentText>
          Les NAFs <InternalDialogArticle slug="vilkar-medlemskap" text="medlemsvilkår" /> og{' '}
          <InternalDialogArticle slug="personvern" text="personvernerklæring" />.
        </S.TermsConsentText>
      </S.TermsConsent>
    </GridCol>
  </S.StyledGrid>
);
